import { 
    PEPREPRESENTATIVE_BEGIN,
    PEPREPRESENTATIVE_ADD,
    PEPREPRESENTATIVE_FAILURE,
    PEPREPRESENTATIVE_CLEAR,

    PEPREPRESENTATIVE_FILTER_BEGIN,
    PEPREPRESENTATIVE_FILTER_SUCCESS,
    PEPREPRESENTATIVE_FILTER_FAILURE,
    PEPREPRESENTATIVE_FILTER_CLEAR

} from 'app/actions/PEPRepresentativeActions';

const initialState = {
	byId: {},
    allIds: [],
    filterData: [],
	isLoading: false,
};

export default function PEPRepresentativeReducer (state = initialState, action) {
	switch (action.type) {
        case PEPREPRESENTATIVE_BEGIN: 
			return {
				...state,
				isLoading: true
			}
        case PEPREPRESENTATIVE_ADD:
			let allIds = action.payload.data.Data;
			return {
				...state,
				allIds,
				isLoading: false,
            };
        case PEPREPRESENTATIVE_CLEAR:
            return {
                ...state,
                byId: {},
                allIds: [],
                isLoading: false,
            }
        case PEPREPRESENTATIVE_FAILURE: 
			return {
				...state,
				isLoading: false
            }
        case PEPREPRESENTATIVE_FILTER_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case PEPREPRESENTATIVE_FILTER_SUCCESS:
            let filterData = [...new Set(state.filterData.concat(action.payload.filterData))];
            return {
                ...state,
                filterData,
                isLoading: false,
            };
        case PEPREPRESENTATIVE_FILTER_CLEAR:
            return {
                ...state,
                filterData: [],
                isLoading: false,
            }
        case PEPREPRESENTATIVE_FILTER_FAILURE:
            return {
                ...state,
                isLoading: false
            }
		default:
			return state;
	}
};

export const getPEPRepresentative = state => {
    return state.allIds;
}

export const getIsLoadingPEPRepresentative = state => {
    return state.isLoading;
}

export const getPEPRepresentativeFilter = state => {
    return state.filterData
}
export const getIsLoadingPEPRepresentativeFilter = state => {
    return state.isLoading;
}